import RegionalBureausPanel from './RegionalBureausPanel';

export default RegionalBureausPanel;
